import axios from 'axios'
import { BACKEND_URL } from '../config'

const API_URL = `${BACKEND_URL}/api`;
// 1. Always pull the LATEST token from storage right as the request fires
/* const userToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null;
const refreshToken = localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null; */
/* console.log(refreshToken)
console.log(userToken) */


export const api = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    //   'Authorization': `Bearer ${userToken}`,
    },
  });


  // Request Intercepter - set Authorization token on Protected urls
  api.interceptors.request.use((config) => {
    const userToken = localStorage.getItem('accessToken');
    // add Authorization token to headers
    // const requireToken = config.url.includes('/user/'||'/users/');
    if (userToken){
        config.headers['Authorization'] = `Bearer ${userToken}`;
    }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }

  );

  // Response interceptor to handle token refresh
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const requestUrl = originalRequest?.url || '';
  
      // Don't attempt token refresh for login/register endpoints
      const isAuthEndpoint = requestUrl.includes('/login/') ||
                             requestUrl.includes('/register/') ||
                             requestUrl.includes('/token/refresh/');

  
      // If token expired and we haven't retried yet (and it's not a login attempt)
      if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry && !isAuthEndpoint) {
        console.log("Token Expired, refreshing")
        originalRequest._retry = true;

        try {
          const refreshToken = localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null;

          // Try to refresh the token - cookies sent automatically with withCredentials
          const refresh =await axios.post(
            `${API_URL}/token/refresh/`,
            {refresh: refreshToken},
            // { withCredentials: false }
          );

          localStorage.setItem("accessToken", refresh.data.access);
          localStorage.setItem("refreshToken", refresh.data.refresh);
          
          /* userToken = refresh.data.access;
          console.log(userToken) */
  
          // Token refreshed via cookies, retry the original request
          console.log("access and refresh tokens refreshed successfully.")
          return api(originalRequest);
        } catch (refreshError) {
          console.log("refresh token expired, please log in again.")
          // Refresh failed - only redirect if on a PROTECTED route
          const currentPath = window.location.pathname;
  
          // Public routes that don't require authentication
          const isPublicRoute = currentPath === '/' ||
                                currentPath.includes('/login/') ||
                                currentPath.includes('/register/') ||
                                currentPath.startsWith('/search') ||
                                currentPath.startsWith('/providers/') ||
                                currentPath === '/terms' ||
                                currentPath === '/privacy' ||
                                currentPath === '/about' ||
                                currentPath === '/contact' ||
                                currentPath === '/support' ||
                                currentPath === '/join';
  
          // Only redirect to login if user is on a protected route
          if (!isPublicRoute) {
            let loginUrl = '/login/'; // default
  
            if (currentPath.startsWith('/dashboard')) {
              loginUrl = '/login/provider';
            } else if (currentPath.startsWith('/admin')) {
              loginUrl = '/admin/login';
            } else if (currentPath.startsWith('/my')) {
              loginUrl = '/login/client';
            } else if (currentPath.startsWith('/support-portal')) {
              loginUrl = '/admin/login';
            }
  
            window.location.href = loginUrl;
          }
          return Promise.reject(refreshError);
        }
      }
  
      return Promise.reject(error);
    }
  );